import angular from 'npm/angular';
import uiRouter from 'npm/angular-ui-router';
import QuotesInterCityComponent from './quotes-intercity.component.js';
import ngMdIcons from 'npm/angular-material-icons';
import register from 'common/register';
import './quotes-intercity.scss';

let quotesInterCityModule = angular.module('quotesInterCity', [
    uiRouter,
    ngMdIcons
])

.config(($stateProvider, $urlRouterProvider) => {
    "ngInject";
    $urlRouterProvider.otherwise('/');

    $stateProvider
        .state('base.quotesInterCity', {
            url: '/order/:orderId/quotes-for-intercity-order',
            template: '<quotes-inter-city></quotes-inter-city>'
        })
        .state('base.quotesInterCity-admin', {
            url: '/order/admin/:orderId/quotes-for-intercity-order',
            template: '<quotes-inter-city></quotes-inter-city>'
        });
});

register('quotesInterCity').
    directive('quotesInterCity', QuotesInterCityComponent);

export default quotesInterCityModule;



// WEBPACK FOOTER //
// ./client/app/components/quotes-intercity/quotes-intercity.js